import request from '@/utils/request'

export function hotProductList() {
  return request({
    url: `/api/home/hotProductList`,
    method: 'get'
  })
}

export function newProductList() {
  return request({
    url: `/api/home/newProductList`,
    method: 'get'
  })
}

export function recommProductList() {
  return request({
    url: `/api/home/recommendProductList`,
    method: 'get'
  })
}

export function bestProductList() {
  return request({
    url: `/api/home/bestProductList`,
    method: 'get'
  })
}

export function subjectList() {
  return request({
    url: `/api/home/subjectList`,
    method: 'get'
  })
}

export function categoryList() {
  return request({
    url: `/api/home/productCateList`,
    method: 'get'
  })
}

export function advertiseList(type) {
  return request({
    url: `/api/home/advertise/${type}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/homeData.js